"use strict";require("../../../runtime/vdom/marko-namespace");
var registry = require("@internal/components-registry");

exports.getComponentForEl =
require("@internal/components-util").T_;
exports.init = registry.U_;
exports.register = function (id, component) {
  registry.r(id, function () {
    return component;
  });
};